import styled from 'styled-components';

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem 0 1.5rem 0;

  & > form {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      flex-direction: row;
      max-width: 35rem;
    }

    & > .ant-form-item {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 80%;
      }

      & label {
        &:after {
          content: '';
        }
        font-size: 0.875rem;
        font-weight: 700;
        color: ${({ theme }) => theme.colors.grayDark2};
      }

      & > .ant-form-item-control {
        width: 100%;
      }
    }
  }

  & > header {
    display: flex;
    align-items: center;
    margin-top: 0.5rem;
    margin-bottom: 0.75rem;
    color: ${({ theme }) => theme.colors.gray5};

    & > span {
      font-weight: 600;
    }
  }
`;

export const FormContainer = styled.div`
  display: flex;
  width: 43rem;
  column-gap: 1rem;
  justify-content: end;
  align-items: flex-end;
  line-height: 1rem;

  & .input-wrapper {
    width: 30rem;
  }

  & button {
    width: 12rem;
    height: 2.8125rem;
  }
`;
